<template>
    <div class="container">
        <div v-if="batteryLevel != null" class="row card border-primary mt-1">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" :class="getStatusCss()">
                    <label>Battery Status</label>
                    <div class="text">{{ batteryLevel != null ? `${batteryLevel.toFixed(0)} %${charging ? " (charging)" : ""}` : "n/a" }} </div>
                </li>
                <li v-show="showLess20()" class="list-group-item bg-warning">
                    <div class="text">Battery Life {{ batteryLevel.toFixed(0)}}%, Charge/Replace Battery</div>
                    <button-button type="button" class="btn btn-sm bg-white" aria-label="Close" @click="close20Clicked">Close</button-button>
                </li>
                <li v-show="showLess10()" class="list-group-item bg-danger text-white">
                    <div class="text">Battery Life Is Critically Low {{ batteryLevel.toFixed(0)}}%, Charge/Replace Now</div>
                    <button-button type="button" class="btn btn-sm bg-white" aria-label="Close" @click="close10Clicked">Close</button-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .card {
        .card-header {
            font-size:20px;
            font-weight: bold;
        }
        ul {
            padding-right: 0;
        }
        li {
            display: flex;
            align-items: center;
            div {
                flex-grow: 1;
            }
        }
        label, .text {
            display: inline-block;
        }
        label {
            font-weight: bold;
            width: 200px;
        }
    }
</style>

<script lang="ts">

import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import BatteryInfoDto from "@/shared/models/BatteryInfoDto";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { Global } from "@/support/GlobalData";
import { SignalR } from "@/support/SignalR";
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            less20WasShown: false,
            less10WasShown: false,
        };
    },
    props: {
        batteryLevel: { type: Number, required: true },
        charging: { type: Boolean, required: true },
    },
    methods: {
        getStatusCss(): string {
            if (this.batteryLevel == null) return ""; // nothing to report
            if (this.showLess10() || this.showLess20()) return "";// don't over-colorize, we have alerts showing
            if (this.batteryLevel > 10 && this.batteryLevel <= 20) return "bg-warning";
            if (this.batteryLevel <= 10) return "bg-danger text-white";
            return "";
        },
        showLess20(): boolean {
            if (this.batteryLevel === null) return false;// nothing to report
            if (this.charging) return false;// don't show
            if (this.less20WasShown) return false;// already shown
            return this.batteryLevel > 10 && this.batteryLevel <= 20;
        },
        showLess10(): boolean {
            if (this.batteryLevel === null) return false;// nothing to report
            if (this.charging) return false;// don't show
            if (this.less10WasShown) return false;// already shown
            return this.batteryLevel <= 10;
        },
        close20Clicked(): void {
            this.less20WasShown = true;
            CalibrationEventSupport.sendEvent(CalibrationEvent.BatteryLowAcknowledged20ByCompanion);
        },
        close10Clicked(): void {
            this.less20WasShown = this.less10WasShown = true;
            CalibrationEventSupport.sendEvent(CalibrationEvent.BatteryLowAcknowledged10ByCompanion);
        },
    },
    mounted(): void {
        SignalR.onBatteryInformation = (info: BatteryInfoDto): void => {
            Global.BatteryPercentageFull = info.PercentageFull;
            Global.BatteryExternalPower = info.ExternalPowerInd;
            Global.MainApp.updateHeader();
        };
        SignalR.onBatteryLowAcknowledged20 = (): void => {
            this.less20WasShown = true;
        };
        SignalR.onBatteryLowAcknowledged10 = (): void => {
            this.less20WasShown = this.less10WasShown = true;
        };
    },
    unmounted(): void {
        SignalR.onBatteryInformation = null;
        SignalR.onBatteryLowAcknowledged20 = null;
        SignalR.onBatteryLowAcknowledged10 = null;
    }
});

</script>
